export default "__VITE_ASSET__QGvXr99a__"